import { useConductorComponent } from "@faire/deprecated-retailer-visitor-shared/features/Conductor/useConductorComponent";
import { useSettingInvalidateProductReviewConductorCampaignDelayMs } from "@faire/deprecated-retailer-visitor-shared/settings/useSettingInvalidateProductReviewConductorCampaignDelayMs";
import { Message } from "@faire/messenger/MessageChannel/MessageChannel";
import { ConductorSurface } from "@faire/web-api--source/indigofair/data/ConductorSurface";
import { IWebSocketMessage } from "@faire/web-api--source/indigofair/websockets/IWebSocketMessage";
import { useCallback } from "react";

export const useConductorInvalidationFunctions = () => {
  const { invalidateConductorComponentQuery: invalidateSiteWideTopBanner } =
    useConductorComponent({
      surface: ConductorSurface.SITE_WIDE_TOP_BANNER,
    });
  const { invalidateConductorComponentQuery: invalidateReviewsFeedBanner } =
    useConductorComponent({
      surface: ConductorSurface.REVIEWS_FEED_PAGE_TOP,
    });

  return {
    invalidateSiteWideTopBanner,
    invalidateReviewsFeedBanner,
  };
};

export const useInvalidateProductReviewCampaignComponents = () => {
  const invalidateDelayMs =
    useSettingInvalidateProductReviewConductorCampaignDelayMs();
  const { invalidateSiteWideTopBanner, invalidateReviewsFeedBanner } =
    useConductorInvalidationFunctions();

  const handleInvalidateProductReviewCampaignComponents = useCallback(
    (message: Message) => {
      if (
        message.type === IWebSocketMessage.Type.PRODUCT_REVIEW_INCENTIVE_GRANTED
      ) {
        const invalidateConductorComponents = () => {
          invalidateSiteWideTopBanner();
          invalidateReviewsFeedBanner();
        };
        // Invalidate immediately to update the banners, and then again after the delay.
        // The dual invalidation is necessary because, for the incentive granted case,
        // the backend processes the incentive with a delay. The first invalidation updates
        // the UI optimistically, but a second invalidation is needed after the backend has
        // finished processing to ensure the banners reflect the final state from the backend.
        invalidateConductorComponents();
        if (invalidateDelayMs > 0) {
          setTimeout(() => invalidateConductorComponents(), invalidateDelayMs);
        }
      }
    },
    [
      invalidateSiteWideTopBanner,
      invalidateReviewsFeedBanner,
      invalidateDelayMs,
    ]
  );

  return { handleInvalidateProductReviewCampaignComponents };
};
